/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Search_Location_OffInputs */

const en_directory_search_location_off = /** @type {(inputs: Directory_Search_Location_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location is off. Type a city instead.`)
};

const pl_directory_search_location_off = /** @type {(inputs: Directory_Search_Location_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lokalizacja jest wyłączona. Wpisz miasto.`)
};

/**
* | output |
* | --- |
* | "Location is off. Type a city instead." |
*
* @param {Directory_Search_Location_OffInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const directory_search_location_off = /** @type {((inputs?: Directory_Search_Location_OffInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Search_Location_OffInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_directory_search_location_off(inputs)
	return en_directory_search_location_off(inputs)
});